import { ApiSchemas } from '..'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export default {
  async list(query?: ApiSchemas['ListCidDto']) {
    return wrapEndpoint(() => client.GET('/cid', { params: { query } }))
  },
}
